import React from "react";
import { connect } from "react-redux";

class Statistics extends React.Component<any, any> {
  render() {
    const { live } = this.props;

    return (
      <div className="col-xs-2 sn-po-colored-boxe" style={{ marginTop: "10px" }}>
        <div className="sn-orange-box">
          <span> {live.today_events} </span>
          <p className="text-gray"> Today Events </p>
        </div>
        <div className="sn-purple-box">
          <span> {live.weekly_events} </span>
          <p className="text-gray"> Weekly Events </p>
        </div>
        <div className="sn-yellow-box">
          <span className=""> {live.monthly_events} </span>
          <p className="text-gray"> Monthly Events </p>
        </div>
        <div className="sn-green-box">
          <span className=""> {live.total_events} </span>
          <p className="text-gray"> Total Events </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  live: state.live.statistics,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);
